import React from 'react';
import InfoModal from './infoModal';

const JOBS = [
  {
    company: 'Manulife',
    role: 'Senior Manager, Product Owner',
    dates: 'Jul 2024 – Present',
    points: [
      'Architected an enterprise-grade, AI-powered analytics platform centralising multi-market VoC data, defining the event taxonomy and data instrumentation standards to enable consistent downstream analytics and model training',
      'Owned product roadmap and KPI framework, partnering with business and Group Technology to prioritise use cases, measure adoption, and drive benefit realisation across APAC',
      'Established governance and review processes for model deployment and data quality, reducing time-to-insight by 4.8% and improving data completeness by 92%',
      'Led cloud migration and data-quality remediation as Delivery Lead, implementing CI/CD pipelines and SDLC governance improvements to increase release frequency and reduce post-release defects',
      'Coordinated regulatory re-domiciliation with Group Risk and Compliance, embedding practical control points and audit trails to ensure compliance readiness',
    ],
  },
  {
    company: 'Ernst & Young',
    role: 'Manager',
    dates: 'Dec 2021 – Jul 2024',
    points: [
      'Drove AI strategy to modernise business development, designing AI-powered client demos and automation that improved reporting efficiency and accuracy',
      'Led capability building workshops on Generative AI, strengthening organisational AI literacy and accelerating adoption across client engagements',
      'Performed technical readiness assessments for eMPF (Mandatory Provident Fund Schemes Authority), evaluating SDLC and testing lifecycle to improve software quality, with executive reporting and remediation roadmaps',
      'Directed a USD80M automation programme at AIA, refining SDLC governance and integrating AI and automation to automate 100+ controls across finance, HR and distribution, managing 56 developers',
    ],
  },
  {
    company: 'FDM',
    role: 'IT Consultant',
    dates: 'Aug 2019 – Dec 2021',
    points: [
      'Manulife — mitigated cybersecurity risks across APAC applications and servers, reducing threats by 30% through OS/DB hardening and penetration testing',
      'DBS — optimised data analytics workflows using Adobe Analytics, VBA, and Qualtrics for a private banking app',
      'HSBC — architected a SQL*Plus-based framework to support a cloud migration to Google Cloud Platform',
    ],
  },
  {
    company: 'Sierra Wireless',
    role: 'Junior Software Developer',
    dates: 'Jul 2017 – Aug 2018',
    points: ['Developed Python automated verification tests for IoT firmware'],
  },
];

function ExperienceModal(props) {
  return (
    <InfoModal title="Work Experience" {...props}>
      {JOBS.map((job) => (
        <article key={job.company} className="info-entry">
          <header className="info-entry-head">
            <div>
              <h3 className="info-org">{job.company}</h3>
              <p className="info-meta">{job.role}</p>
            </div>
            <p className="info-dates">{job.dates}</p>
          </header>
          <ul className="info-list">
            {job.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </article>
      ))}
    </InfoModal>
  );
}

export default ExperienceModal;
